<template>
  <div @click="select">
    <li
      class="list-group-item d-flex justify-content-between align-items-start"
      v-bind:class="{ active: layerActive }"
    >
      <span class="handle">
        <b-icon-arrow-down-up></b-icon-arrow-down-up>
      </span>
      <input
        class="form-control layer-summary-text-detail"
        type="text"
        placeholder="layer name"
        v-model="value.layer_name"
      />
      <div class="layer-item-pieces">{{ $t("UNITS") }}{{ value.images.length }}</div>
      <!-- <span class="badge bg-primary rounded-pill">{{
        value.images.length
      }}</span> -->
      <span class="bl-icon-delete">
        <b-icon-x-circle
          class="delete-button"
          aria-hidden="true"
          @click="deleteClick"
        ></b-icon-x-circle>
      </span>
    </li>
  </div>
</template>
<script>
import { i18n } from '../lang'

export default {
  name: "LayerItem",
  props: ["value"],
  mounted() {
    this.deleteFlag = false;
    this.layer_id = this.value.layer_id;
  },
  data() {
    return {
      deleteFlag: false,
      layerActive: false,
      layer_id: "",
    };
  },
  methods: {
    setLayerActive(value) {
      this.layerActive = value;
    },
    deleteClick() {
      this.deleteFlag = true;
    },
    select(event) {
      if (this.deleteFlag === true) {
        var self = this;
        this.$bvModal
          .msgBoxConfirm(i18n.t("DEL_LAYER"))
          .then((value) => {
            if (value === true) {
              this.$emit("click", {
                layer_id: self.value.layer_id,
                layer_name: self.value.layer_name,
                layer_order: self.value.layer_order,
                layer_probability: self.value.layer_probability,
                images: self.value.images,
                deleteFlag: self.deleteFlag,
              });
            } else {
              this.deleteFlag = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.layerActive = true;
        this.$emit("click", {
          layer_id: this.value.layer_id,
          layer_name: this.value.layer_name,
          layer_order: this.value.layer_order,
          layer_probability: this.value.layer_probability,
          images: this.value.images,
          deleteFlag: this.deleteFlag,
        });
      }
    },
  },
};
</script>
<style scoped>
.delete-button {
  width: 25px;
  height: 25px;
  color: #000000;
  margin-left: 8px;
  cursor: pointer;
}
.handle {
  color: #000000;
  /* padding: 5px; */
  margin-right: 10px;
  cursor: move;
}
.layer-summary-text-detail {
  text-align: left;
  padding-top: 3px;
  margin-right: 8px;
  font: normal normal 600 16px/18px Noto Sans;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}
li {
  background: #101010 0% 0% no-repeat padding-box;
  border: 2px solid #191919;
  border-radius: 10px;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/LayerItem.vue